import { render, staticRenderFns } from "./Wallboard.vue?vue&type=template&id=64ee06c2&scoped=true&"
import script from "./Wallboard.vue?vue&type=script&lang=js&"
export * from "./Wallboard.vue?vue&type=script&lang=js&"
import style0 from "./Wallboard.vue?vue&type=style&index=0&id=64ee06c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ee06c2",
  null
  
)

export default component.exports